import { GetServerSideProps, NextPage } from 'next'
import { GlobalRequest } from '~/components/global-requset'
import { Container } from '~/components/ui/Container'
import { Layout } from '~/layouts/default'

import * as api from '~/apis'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { SEOHead } from '~/components/business/SEOHead'
import { HtmlContent } from '~/components/ui/HtmlContent'

const Page: NextPage<{
  data: any
}> = ({ data }) => {
  return (
    <Layout>
      <SEOHead title="AI创作服务协议" />
      <Container>
        <PageCrumbs title="AI创作服务协议" center />
        <HtmlContent data={data.content} />
      </Container>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState } = await GlobalRequest(context)
  const dataRes = await api.getConfig({
    data: {
      key: 'trade.config.aiAgreement',
    },
  })

  return {
    props: {
      initialState,
      data: JSON.parse(dataRes.data.data) || {},
    },
  }
}

export default Page
